import { render, staticRenderFns } from "./ghdy3.vue?vue&type=template&id=6a1b18a2&scoped=true"
import script from "./ghdy3.vue?vue&type=script&lang=js"
export * from "./ghdy3.vue?vue&type=script&lang=js"
import style0 from "./ghdy3.vue?vue&type=style&index=0&id=6a1b18a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1b18a2",
  null
  
)

export default component.exports